<template>
  <el-container class="main-page">
    <el-main class="content-view">
      <transition name="slide-fade">
        <router-view :key="$route.fullPath" />
      </transition>
    </el-main>
    <el-footer class="show-phone" style="height: 50px">
      <div class="text-center">
        <van-tabbar route v-model="active" @change="onChange">
          <van-tabbar-item replace to="/flowPublic/flowList" icon="wap-home">首页</van-tabbar-item>
          <van-tabbar-item replace to="/flowPublic/flowDetailBySelf/&add" icon="add"></van-tabbar-item>
          <van-tabbar-item replace to="/flowPublic/flowListBySelf" icon="manager">我的</van-tabbar-item>
        </van-tabbar>
      </div>
    </el-footer>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      userInfo: {},
      version: '',
      active: 0
    }
  },
  watch: {
    $route: 'routerChange'
  },
  methods: {
    routerChange() {
      if (this.$route.name === 'Case') {
        this.active = 1
      } else if (this.$route.name === 'Customer') {
        this.active = 0
      } else {
        this.active = ''
      }
    },
    onChange(index) {
      console.log(index)
    },
    showBar() {
      console.log(this.$route.path.indexOf('case') >= 0 || this.$route.path.indexOf('customer') >= 0)
      if (this.$route.path.indexOf('case') >= 0 || this.$route.path.indexOf('customer') >= 0) {
        return true
      } else {
        return false
      }
    }
  },
  mounted() {
    if (this.$route.name === 'Case') {
      this.active = 1
    } else if (this.$route.name === 'Customer') {
      this.active = 0
    } else {
      this.active = ''
    }
    console.log(this.$route)
  },
  beforeDestroy() {}
}
</script>
<style></style>
<style scoped lang="less">
/* 整个区域 */
.main-page {
  .flow-title {
    font-size: 18px;
    line-height: 50px;
  }
  .el-header {
    background: #fff;
  }
  .main-header {
    height: 50px;
    padding: 0;
    z-index: 9;
  }
  .self-aside {
    position: relative;
    ul {
      background: #fff;
    }
  }
  .content-view {
    padding: 0;
    height: 100vh;
    overflow-x: hidden;
    overflow-y: auto;
    background: #f0f0f0;
  }
}
@media screen and (max-width: 768px) {
  .flow-title {
    font-weight: 700;
    font-size: 1.4rem !important;
    line-height: 50px !important;
    margin-bottom: 3vw;
    height: auto !important;
  }
  .main-page {
    .content-view {
      padding: 0;
      height: 100vh;
      overflow-x: hidden;
      overflow-y: auto;
      background: #f0f0f0;
    }
  }
}
</style>
